module.exports = __webpack_public_path__ + "img/shield_check.02860d2.svg";